import { render } from "./PasswordRecovery.vue?vue&type=template&id=cad33556&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=cad33556&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cad33556"

export default script